import { render } from "./sharePlanModal.vue?vue&type=template&id=5468a91c"
import script from "./sharePlanModal.vue?vue&type=script&lang=js"
export * from "./sharePlanModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__